/* eslint-disable camelcase */

// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';

// app modules: components
import Button from 'components/Button';
import Heading from 'components/Heading';
import { UnorderedList } from 'components/List';
import RelatedContentItem from 'components/RelatedContentItem';

// app modules: props
import RelatedContentProps from 'components/RelatedContent/RelatedContentProps';

// assets
import CssRelatedContent from './RelatedContent.scss';

class RelatedContent extends Component {
  static propTypes = {
    heading: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(RelatedContentProps.item),
    visibleItems: PropTypes.number,
    dualColumn: PropTypes.bool,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    items: [],
    visibleItems: 4,
    dualColumn: false,
    loading: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      showAll: false,
    };

    this.bound = {
      toggleShowAll: this.toggleShowAll.bind(this),
    };
  }

  toggleShowAll() {
    const { showAll } = this.state;
    this.setState({
      showAll: !showAll,
    });
  }

  renderToggleButton(items) {
    const { visibleItems } = this.props;
    const { showAll } = this.state;

    if (items.length > visibleItems) {
      return (
        <Button
          themeName="energized"
          themeType="clear"
          size="large"
          onClick={this.bound.toggleShowAll}
        >
          {showAll ? 'Hide' : `Show all (${items.length})`}
        </Button>
      );
    }

    return null;
  }

  render() {
    const { heading, items, visibleItems, dualColumn, loading } = this.props;
    const { showAll } = this.state;
    const limit = showAll ? items.length : visibleItems;

    if (items.length === 0 && !loading) {
      return null;
    }

    const content = items
      .slice(0, limit)
      .map(item => <RelatedContentItem key={item.id} item={item} loading={loading} />);

    const listClassName = classNames('related-content', {
      'related-content__dual-column': dualColumn,
      'related-content__single-column': !dualColumn,
    });

    return (
      <div className="related-content">
        <header className="related-content__header">
          <Heading>{heading}</Heading>
          {this.renderToggleButton(items)}
        </header>
        <UnorderedList className={listClassName} vertical spaceBetween="none">
          {content}
        </UnorderedList>
      </div>
    );
  }
}

export default withStyles(CssRelatedContent)(RelatedContent);
